export const searchConstants = {
  SET_SEARCH_LOADING: 'search/SET_SEARCH_LOADING',
  SET_SEARCH_ERROR: 'search/SET_SEARCH_ERROR',
  GET_SEARCH: 'search/GET_SEARCH',
  SET_SEARCH: 'search/SET_SEARCH',
  GET_H2_CARD_SEARCH: 'search/GET_H2_CARD_SEARCH',
  SET_H2_CARD_SEARCH: 'search/SET_H2_CARD_SEARCH',
};
